"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearingInput = void 0;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
const bearing_input_style_1 = require("./bearing.input.style");
const input_1 = require("./input");
const unit_1 = require("./unit");
(0, theme_1.addStyles)(bearing_input_style_1.Style);
exports.BearingInput = {
    view(state) {
        return (0, mithril_1.m)('div', { className: bearing_input_style_1.CSS.container }, [
            input_1.Input.view(state),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_DEGREE)
        ]);
    }
};
//# sourceMappingURL=bearing.input.js.map